// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SAVE_AS = "Ulo\u017e jako...";
export const SAVE_AS_DRAFT = "Ulo\u017e jako rozepsan\u00fd (nepublikovan\u00fd)";
export const SAVE_AS_PUBLISHED = "Ulo\u017e a publikuj";
export const SEO_TITLE_BLOGS_article = "%(article)s";
